import type RecipientWellWithFindControlViewState from 'owa-recipient-types/lib/types/RecipientWellWithFindControlViewState';
import type ServicesRequestStatus from './ServicesRequestStatus';
import type UserInfo from './UserInfo';
import type RecipientInfo from './RecipientInfo';
import type LinkAccessType from './LinkAccessType';
interface SharedViewState {
    shareEventId: string;
    shareEventTitle: string;
    shareMessage: string;
    shareTheme: string;
    shareMeetingTypeDuration: string;
    shareMeetingDescription: string;
    shareRecipients: RecipientWellWithFindControlViewState;
    shareLink: string;
    createLinkStatus: ServicesRequestStatus;
    isSingleUse: boolean;
    isAttendeeAuthRequired: boolean;
    allowedAttendees: RecipientInfo[];
    isPrivate: boolean;
    linkAccessType: LinkAccessType;
    invalidAccessAttendees: UserInfo[];
    noAttendeeWarning: boolean;
    showShareModal: boolean;
}

export const SHARE_BOOKING_PAGE_ID = 'bookingPage';

export default SharedViewState;
